export default theme => {
    return {}
}



// WEBPACK FOOTER //
// ./src/app/configuration/ComcastPremarket/theme/components/scorecard/MetricsLabels/index.js